import React, { useState } from "react";
import classNames from "classnames";

// HOOKS
import useChatBot from "../../hooks/useChatBot";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import ChatBotTable from "./ChatBotTable";
import { ChatBotDialog } from "./ChatBotTable";

function ChatBotMain() {
  const { datas, error, loading, getData } = useChatBot();

  const [showModal, setShowModal] = useState(false);

  if (loading) {
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  }
  if (error) return <ContainerContent>Error</ContainerContent>;

  const refresh = async () => {
    await getData();
  };

  return (
    <ContainerContent>
      <div className="mx-2 mb-2">
        <button
          onClick={() => setShowModal(true)}
          className={classNames(
            "mx-2 px-3 py-3 h-full text-sm rounded text-white shadow-sm duration-300 transition-all focus:outline-none bg-blue-500 hover:bg-blue-600"
          )}
        >
          เพิ่มข้อมูล
        </button>
        <button
          className="mx-2 px-3 py-3 h-full text-sm rounded text-white shadow-sm duration-300 transition-all focus:outline-none bg-indigo-500 hover:bg-indigo-600"
          onClick={refresh}
        >
          Refresh
        </button>
      </div>

      <ChatBotTable data={datas} getData={getData} />
      <ChatBotDialog
        getData={getData}
        row={{ original: { keyword: [], answer: "", order: null } }}
        showModal={showModal}
        setShowModal={setShowModal}
        isCreated={true}
      />
    </ContainerContent>
  );
}

export default ChatBotMain;
